<template>
  <div class="p-products">
    <section class="c-p-r products-top">
      <div class="c-d-f c-fd-c c-ai-c c-p-c c-ta-c c-c-white cm-width products-top-desc">
        <p class="c-fs-38 c-mb-32 c-fw-b top-title">技术支持服务</p>
        <p class="c-fs-16 c-ff-l c-mb-36 top-desc">让专业的人做专业的事，拥有国内外顶级运维专家为用户保驾护航</p>
        <!-- <div class="c-d-f c-jc-c c-ff-b c-w-100">
          <button class="c-btn-dark-156 c-btn-trans">查看培训行程</button>
          <button class="c-ml-12 c-btn-156-nob">申请培训</button>
        </div> -->
      </div>
    </section>
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="c-pt-80 c-pb-40 c-m-a cm-width products-medium">
        <section class="c-d-f">
          <div class="c-d-f c-fd-c c-ai-c c-f-1 c-ta-c c-b-r c-pt-24">
            <div class="c-ta-c">
              <img src="../assets/products/products1.png">
              <p class="c-fs-20 c-c-text-blue">完善的服务体系</p>
              <p class="c-pt-20 c-mb-8 c-fs-14 c-c-text-grey">遵循ITIL4/ITSS标准</p>
              <p class="c-fs-14 c-c-text-grey">提供专属服务顾问</p>
            </div>
          </div>
          <div class="c-d-f c-fd-c c-ai-c c-f-1 c-ta-c c-b-r c-pt-24">
            <div class="c-ta-c">
              <img src="../assets/products/products2.png">
              <p class="c-fs-20 c-c-text-blue">即时响应式支持</p>
              <p class="c-pt-20 c-mb-8 c-fs-14 c-c-text-grey">99.9%运维服务保障</p>
              <p class="c-fs-14 c-c-text-grey">电话、远程、现场支持</p>
            </div>
          </div>
          <div class="c-d-f c-fd-c c-ai-c c-f-1 c-ta-c c-pt-24">
            <div class="c-ta-c">
              <img src="../assets/products/products3.png">
              <p class="c-fs-20 c-c-text-blue">强大的专家团队</p>
              <p class="c-pt-20 c-fs-14 c-c-text-grey">10年+全行业服务经验</p>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="c-pt-40 c-pb-24 cm-width products-medium-mobile">
        <div class="c-mb-8 c-bc-white products-medium-item">
          <div class="c-bc-white c-d-f c-pe-none">
            <img src="../assets/products/products1.png">
            <div class="c-ml-24">
              <p class="c-fs-15 c-c-text-blue c-mb-8">完善的服务体系</p>
              <ul class="c-fs-12 c-lh-20 c-ml-20 c-ta-j c-c-text-grey">
                <li>遵循ITIL4/ITSS标准</li>
                <li>提供专属服务顾问</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="c-mb-8 c-bc-white products-medium-item">
          <div class="c-bc-white c-d-f c-pe-none">
            <img src="../assets/products/products2.png">
            <div class="c-ml-24">
              <p class="c-fs-15 c-c-text-blue c-mb-8">即时响应式支持</p>
              <ul class="c-fs-12 c-lh-20 c-ml-20 c-ta-j c-c-text-grey">
                <li>99.9%运维服务保障</li>
                <li>电话、远程、现场支持</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="c-bc-white products-medium-item">
          <div class="c-bc-white c-d-f c-pe-none">
            <img src="../assets/products/products3.png">
            <div class="c-ml-24">
              <p class="c-fs-15 c-c-text-blue c-mb-8">强大的专家团队</p>
              <ul class="c-fs-12 c-lh-20 c-ml-20 c-ta-j c-c-text-grey">
                <li>10年+全行业服务经验</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </section>
    <!-- <section class="c-visible-pc">
      <section class="c-d-f c-fw-w c-mt-84 c-fs-20 c-c-text-blue c-bc-white c-cs-p cm-width products-item-wrap">
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item">
          <span>实施部署</span>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item">
          <span>故障排除</span>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item">
          <span>模版开发</span>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item">
          <span>集成服务</span>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item">
          <span>运维大数据深度分析</span>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item">
          <span>版本升级</span>
        </div>
      </section>
    </section>
    <section class="c-visible-mobile">
      <section class="c-d-f c-fw-w c-mt-24 c-fs-15 c-c-text-blue c-bc-white c-cs-p cm-width products-item-wrap-mobile">
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item-mobile">
          <span>实施部署</span>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item-mobile">
          <span>故障排除</span>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item-mobile">
          <span>模版开发</span>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item-mobile">
          <span>集成服务</span>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item-mobile">
          <span>运维大数据深度分析</span>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-p-r products-item-mobile">
          <span>版本升级</span>
        </div>
      </section>
    </section> -->
    <!-- <section class="c-p-r apply-train">
      <div class="c-p-c cm-width">
        <p class="c-ff-l c-ta-c c-m-a c-c-white train-desc">我们的合作伙伴和工程师网络遍布全国，有充足的能力帮助您主动防止宕机，保持系统持续正常运行。</p>
        <div class="c-d-f c-jc-c c-ff-b c-ff-b c-pt-24">
          <button class="c-btn-156-nob" @click="toUrl('/partners')">合作伙伴体系</button>
          <button class="c-ml-12 c-btn-dark-156" @click="toUrl('/support')">认证培训</button>
        </div>
      </div>
    </section> -->
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="c-pb-164 service-assess-wrap">
        <section class="c-m-a cm-width">
          <!-- <div class="c-d-f c-ai-c c-mt-80 c-mb-40">
            <img src="../assets/index/icon.png">
            <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">标准现场实施服务</span>
          </div>
          <p class="c-fs-18 c-mb-40 c-lh-38">多个标准内容可选，按需购买，以最低的成本最有效的解决问题。服务由Zabbix原厂认证工程师提供，他们精通Zabbix，有丰富的经验积累，解决过 多种不同场景的不同需求。
            可根据企业规模，制定从基础框架到配置等多方面定制化的解决方案，以满足企业多场景使用的需求。</p>
          <table class="c-fs-14 c-c-text-grey table-course-overview">
            <tr class="c-fs-14 c-c-text-blue" style="background: #EFF3FC;">
              <td class="c-pl-24" style="width: 20%;">分类</td>
              <td class="c-pl-24" style="width: 25%;">内容</td>
              <td class="c-pl-24" style="width: 15%;">所需人天数</td>
              <td class="c-pl-24" style="width: 25%;">是否需要</td>
              <td class="c-pl-24" style="width: 15%;">总计</td>
            </tr>
            <tr>
              <td rowspan="7" colspan="1" class="c-fs-20 c-c-text-blue c-ta-c" style="background: rgba(239,243,252,0.7);">Zabbix设计<br/>部署和优化</td>
            </tr>
            <tr v-for="item in tableData" :key="item.id">
              <td class="c-pl-24">{{item.content}}</td>
              <td class="c-pl-24">{{item.days}}</td>
              <td class="c-pl-24">
                <el-select v-model="item.isNeed" @change="(value) => selectChange(value, item.id)" placeholder="请选择">
                  <el-option
                    v-for="i in selectList"
                    :key="i.value"
                    :label="i.label"
                    :value="i.value">
                  </el-option>
                </el-select>
              </td>
              <td class="c-pl-24">{{item.total}}</td>
            </tr>
          </table>
          <div class="c-d-f c-ai-c c-mt-40">
            <div class="c-mr-12 c-dot"></div>
            <p class="c-fs-20 c-lh-38 c-c-text-blue">Notes</p>
          </div>
          <div class="c-fs-18 c-lh-38">
            <p>1.该评估适用于One Server One Proxy环境，多Server多Proxy环境请与我们联系进一步评估。</p>
            <p>2.表格内部署部分人天评估均基于宏时现有模板/监控项库，不属于库内的需求属于定制需求，请与我们联系进一步评估。</p>
            <p>3.对于操作系统部分来说，没有自动部署且不准备自动部署的，按照表格来计算；如需要自动部署，需要工程师单独评估所需人天。</p>
          </div>
          <button class="c-d-b c-fs-16 c-ff-b c-btn-dark-156 service-assess-btn">立即开始评估</button> -->
          <div class="c-pt-44 c-pl-64 c-pb-60 c-p-r customize-service">
            <div style="width: 45%;">
              <div class="c-d-f c-ai-c c-mb-40">
                <img src="../assets/index/icon.png">
                <span class="c-ml-12 c-ff-m c-fs-24">定制化服务</span>
              </div>
              <p class="c-fs-16 c-lh-38">可根据企业规模，制定从基础框架，到配置等多方面定制化的解决方案，以满足企业多场景使用的需求。</p>
              <button class="c-fs-16 c-ff-b c-mt-48 c-btn-dark-124-nob" @click="toUrl('/about')">立即咨询</button>
            </div>
            <img src="../assets/products/products-pic.png" class="pic">
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="c-pb-40 service-assess-wrap-mobile">
        <section class="c-m-a cm-width">
          <!-- <div class="c-d-f c-ai-c c-mt-40 c-mb-24">
            <img src="../assets/index/icon.png" class="c-icon-mobile">
            <span class="c-ml-8 c-c-text-color c-ff-m c-fs-16">标准现场实施服务</span>
          </div>
          <p class="c-fs-12 c-c-text-grey c-mb-24 c-lh-20">多个标准内容可选，按需购买，以最低的成本最有效的解决问题。服务由Zabbix原厂认证工程师提供，他们精通Zabbix，有丰富的经验积累，解决过 多种不同场景的不同需求。
            可根据企业规模，制定从基础框架到配置等多方面定制化的解决方案，以满足企业多场景使用的需求。</p>
          <section class="c-o-s">
            <table class="c-fs-12 c-c-text-grey table-course-overview-mobile">
              <tr class="c-c-text-blue" style="background: #EFF3FC;">
                <td class="c-pl-12" style="width: 20%;">分类</td>
                <td class="c-pl-12" style="width: 25%;">内容</td>
                <td class="c-pl-12" style="width: 15%;">所需人天数</td>
                <td class="c-pl-12" style="width: 25%;">是否需要</td>
                <td class="c-pl-12" style="width: 15%;">总计</td>
              </tr>
              <tr>
                <td rowspan="7" colspan="1" class="c-fs-11 c-c-text-blue c-ta-c" style="background: rgba(239,243,252,0.7);">Zabbix设计<br/>部署和优化</td>
              </tr>
              <tr v-for="item in tableData" :key="item.id">
                <td class="c-pl-12">{{item.content}}</td>
                <td class="c-pl-12">{{item.days}}</td>
                <td class="c-pl-12">
                  <el-select v-model="item.isNeed" @change="(value) => selectChange(value, item.id)" placeholder="请选择">
                    <el-option
                      v-for="i in selectList"
                      :key="i.value"
                      :label="i.label"
                      :value="i.value">
                    </el-option>
                  </el-select>
                </td>
                <td class="c-pl-12">{{item.total}}</td>
              </tr>
            </table>
          </section>
          <div class="c-d-f c-ai-c c-mt-24">
            <div class="c-mr-8 c-dot"></div>
            <p class="c-fs-15 c-lh-20 c-c-text-blue">Notes</p>
          </div>
          <div class="c-fs-12 c-lh-20 c-mt-8 c-c-text-grey">
            <p>1.该评估适用于One Server One Proxy环境，多Server多Proxy环境请与我们联系进一步评估。</p>
            <p>2.表格内部署部分人天评估均基于宏时现有模板/监控项库，不属于库内的需求属于定制需求，请与我们联系进一步评估。</p>
            <p>3.对于操作系统部分来说，没有自动部署且不准备自动部署的，按照表格来计算；如需要自动部署，需要工程师单独评估所需人天。</p>
          </div>
          <button class="c-d-b c-mt-24 c-fs-16 c-ff-b c-btn-dark-156-nob service-assess-btn-mobile">立即开始评估</button> -->
          <div>
            <div class="c-d-f c-ai-c c-mb-16 c-mt-24">
              <img src="../assets/index/icon.png" class="c-icon-mobile">
              <span class="c-ml-8 c-ff-m c-fs-16">定制化服务</span>
            </div>
            <div class="c-ptb-28 c-pl-20 customize-service-mobile">
              <div class="c-d-f c-jc-sb c-ai-c">
                <p class="c-fs-12 c-lh-20">可根据企业规模，制定从基础框架，到配置等多方面定制化的解决方案，以满足企业多场景使用的需求。</p>
                <img src="../assets/products/products-pic.png" class="pic">
              </div>
              <button class="c-fs-16 c-ff-b c-mt-16 c-btn-dark-124-nob" @click="toUrl('/about')">立即咨询</button>
            </div>
          </div>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
const table = [
  {
    id: 0,
    content: 'Zabbix架构设计和咨询',
    days: '2',
    isNeed: '',
    total: 0
  }, {
    id: 1,
    content: 'Zabbix架构设计和咨询',
    days: '3',
    isNeed: '',
    total: 0
  }, {
    id: 2,
    content: 'Zabbix架构设计和咨询',
    days: '4',
    isNeed: '',
    total: 0
  }, {
    id: 3,
    content: 'Zabbix架构设计和咨询',
    days: '5',
    isNeed: '',
    total: 0
  }, {
    id: 4,
    content: 'Zabbix架构设计和咨询',
    days: '6',
    isNeed: '',
    total: 0
  }, {
    id: 5,
    content: 'Zabbix架构设计和咨询',
    days: '7',
    isNeed: '',
    total: 0
  }
]
export default {
  name: 'products',
  data () {
    return {
      list: [],
      tableData: [],
      selectValue: '',
      selectList: [{
        value: true,
        label: '是'
      }, {
        value: false,
        label: '否'
      }]
    }
  },
  methods: {
    toUrl (url) {
      this.$router.push(url)
    },
    selectChange (value, index) {
      const result = this.tableData[index].days * 10
      value ? this.tableData[index].total = result : this.tableData[index].total = 0
    }
  },
  created () {
    this.tableData = table
  }
}
</script>

<style lang="scss">
.p-products {
  min-height: calc(100vh - 90px - 525px);
  .products-top {
    height: 560px;
    @media screen and (max-width: $max-width-standard) {
      height: 232px;
      background: url("../assets/products/products-banner-m.jpg") no-repeat;
      background-size: cover;
      .top-title {
        font-size: 19px;
        margin-bottom: 12px;
      }
      .top-desc {
        width: 70%;
        font-size: 9px;
        line-height: 16px;
        margin-bottom: 15px;
      }
    }
    background: url("../assets/products/products-banner.jpg") no-repeat;
    background-size: cover;
  }
  .products-medium-mobile {
    .products-medium-item {
      padding: 25px 16px;
      padding-right: 24px;
      img {
        width: 73.5px;
        height: 73.5px;
        object-fit: contain;
      }
    }
  }
  .products-item-wrap {
    .products-item {
      width: calc(100% / 3);
      height: 165px;
      box-sizing: border-box;
      border: 1px solid #D1D8E8;
      border-left: none;
      &::before {
        content: "";
        width: 100%;
        height: 4px;
        background: $orange;
        position: absolute;
        top: 0;
        display: none;
      }
      &:hover {
        box-shadow: 0 10px 25px 0 rgba(0, 31, 255, 0.05);
      }
      &:hover::before {
        display: block;
      }
    }
    & .products-item:nth-of-type(1) {
      border-left: 1px solid #D1D8E8;
    }
    & .products-item:nth-of-type(4) {
      border-left: 1px solid #D1D8E8;
      border-top: none;
    }
    & .products-item:nth-of-type(5) {
      border-top: none;
    }
    & .products-item:nth-of-type(6) {
      border-top: none;
    }
  }
  .products-item-wrap-mobile {
    .products-item-mobile {
      width: 50%;
      height: 82px;
      box-sizing: border-box;
      border: 1px solid #D1D8E8;
      border-top: none;
    }
    & .products-item-mobile:nth-of-type(even) {
      border-left: none;
    }
    & .products-item-mobile:nth-of-type(1) {
      border-top: 1px solid #D1D8E8;
    }
    & .products-item-mobile:nth-of-type(2) {
      border-top: 1px solid #D1D8E8;
    }
  }
  .apply-train {
    height: 280px;
    margin-top: 80px;
    @media screen and (max-width: $max-width-standard) {
      height: 192px;
      margin-top: 40px;
      .train-desc {
        width: 70%;
        font-size: 9px;
      }
    }
    background: url("../assets/training/training-blue.png") no-repeat;
    background-size: cover;
  }
  .service-assess-wrap {
    // background: url("../assets/products/products-bg.png") no-repeat;
    // background-size: cover;
    // background-position: center;
    .service-assess-btn {
      margin: 0 auto;
      margin-top: 60px;
    }
    .customize-service {
      min-height: 362px;
      margin-top: 60px;
      background-color: white;
      // background-image: linear-gradient(90deg, #1445C0 0%, rgba(5,36,133,0.13) 100%);
      .pic {
        position: absolute;
        right: 0;
        top: -60px;
      }
    }
    .table-course-overview {
      width: 100%;
      border-collapse: collapse;
      tr {
        border-top: 1px solid #B5C4E8;
        border-bottom: 1px solid #B5C4E8;
        background-color: rgba(255, 255, 255, 0.4);
        td {
          height: 54px;
        }
      }
    }
  }
  .service-assess-wrap-mobile {
    // background: url("../assets/products/products-bg.png") no-repeat;
    // background-size: 100% 30%;
    // background-position: top;
    // .el-input__inner {
    //   height: 34px;
    // }
    .service-assess-btn-mobile {
      margin: 0 auto;
      margin-top: 24px;
    }
    .customize-service-mobile {
      background: white;
      // background-image:  linear-gradient(90deg, #1443B7 0%, #052485 100%);
      p {
        opacity: 0.8;
      }
      .pic {
        width: 112px;
        max-height: 110px;
      }
    }
    .table-course-overview-mobile {
      min-width: 650px;
      border-collapse: collapse;
      tr {
        border-top: 1px solid #B5C4E8;
        border-bottom: 1px solid #B5C4E8;
        background-color: rgba(255, 255, 255, 0.4);
        td {
          height: 40px;
        }
      }
    }
  }
}
</style>
